module.exports = __webpack_public_path__ + "img/moins_2.8b560310.svg";